<template>
    <rkm-modal
        :buttons="buttons"
        @save="handleSave"
        extra-large
        ref="RkmModal"
    >

        <Form
            :data="data"
            :disabled="disabled"
            @saved="saved"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    computed: {
        buttons() {
            let buttons = ['cancel'];

            if(this.data.model.acidenteTrabalho && this.data.model.acidenteTrabalho.parecerMedico){
                if (!this.disabled
                    && (this.data.model.acidenteTrabalho.parecerMedico.lotacao.profissional.id === null ||
                    this.data.form.lotacao.profissional.id === this.data.model.acidenteTrabalho.parecerMedico.lotacao.profissional.id)
                ) {
                    buttons.push('save')
                }
            }

            return buttons
        }
    },
    data: () => ({
        model: null,
    }),
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
        handleSave() {
            this.$refs.Form.save()
        },
        handleExit() {
            this.$refs.RkmModal.hide()
        },
        saved() {
            this.handleExit()
        },
    },
    props: {
        data: { type: Object, required: true },
        disabled: { type: Boolean, default: false }
    },
}
</script>